__turbopack_context__.v({
  "placeholder": "G3vgKW_placeholder",
  "privacy-hint": "G3vgKW_privacy-hint",
  "text": "G3vgKW_text",
});
